import { ServiceUsagesSourceEnum } from '@e-socna/data-layer';

// The edition mode changes the live pricing and its option choice: open while
// either can still change (the option choice outlives the pricing until the
// quotation is approved).
export const isPricingEditionModeAvailable = ({
  isOptionGroupsSelectionEditable,
  isPricingEditable,
  source,
}: Readonly<{
  isOptionGroupsSelectionEditable: boolean;
  isPricingEditable: boolean;
  source: ServiceUsagesSourceEnum;
}>): boolean =>
  source === ServiceUsagesSourceEnum.ServicesInfo &&
  (isPricingEditable || isOptionGroupsSelectionEditable);
